














































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Enums/data
import { QUERY_PARAMS } from "@/data/constants";

// Types
import { IProvisionRequest } from "@/models/provisioning";
import { IProvisionRequestProviderData } from "@/models/providers/provisionRequests";

@Component({
  components: {
    "provision-request-provider": () =>
      import(
        "@/components/app/admin/provisioning/provisionRequestProvider.vue"
      ),
    "request-quick-actions": () =>
      import("@/components/app/admin/provisioning/requestQuickActions.vue"),
    "request-log-info": () =>
      import("@/components/app/admin/provisioning/requestLogInfo.vue")
  }
})
export default class ProvisionRequestModal extends Vue {
  // Props

  @Prop({ required: true })
  public requestId!: IProvisionRequest["id"];

  @Prop({ default: true })
  public routeOpening!: boolean;

  @Prop({ default: false })
  public isCPContext!: boolean;

  // Life-cycle methods

  public created() {
    this.setRouteModalRequestId();
  }

  public beforeDestroy() {
    if (!this.routeModalRequestId) return;
    this.$router.push({
      query: {
        ..._.omit(this.$route.query, QUERY_PARAMS.MODAL_REQUEST_ID)
      }
    });
  }

  // Methods

  public setRouteModalRequestId() {
    if (!this.routeOpening || this.routeModalRequestId) return;

    const query = {};
    query[QUERY_PARAMS.MODAL_REQUEST_ID] = this.requestId;

    this.$router.push({
      query: {
        ...this.$route.query,
        ...query
      }
    });
  }

  public getModalTitle({ request }: IProvisionRequestProviderData) {
    return _.compact([
      this.$t("_.provision_request"),
      request?.function_name
    ]).join(": ");
  }

  public refreshData() {
    this.$bus.$emit("refreshRequestTable");
  }

  // Computed

  public get routeModalRequestId() {
    return _.get(this.$route, `query.${QUERY_PARAMS.MODAL_REQUEST_ID}`, null);
  }

  // Watchers

  @Watch("$route.name")
  public async onRouteNameChange() {
    this.$emit("close");
  }
}
